export const AVATAR_TAG_NAME = "avatar" as const;

export const AVATAR_VARIANTS = ["neutral", "primary", "warning"] as const;

export const AVATAR_KINDS = ["person", "organization"] as const;

export const AVATAR_STATUSES = ["online", "away", "busy", "offline"] as const;
